import { c as _c } from "react/compiler-runtime";
import { TLocoType } from 'shared/hooks/use-loco-translation';
export enum ProductNameTagType {
  PHYSICAL_PRODUCT,
}
const ProductNameTagNames = {
  [ProductNameTagType.PHYSICAL_PRODUCT]: 'dashboard.transactions.physical_product'
};
export interface ProductNameTagProps {
  type: ProductNameTagType;
  t: TLocoType;
}
export const ProductNameTag = t0 => {
  const $ = _c(5);
  const {
    type,
    t
  } = t0;
  let t1;
  if ($[0] !== t || $[1] !== type) {
    t1 = t(ProductNameTagNames[type]).toLowerCase();
    $[0] = t;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="text-text-tertiary bg-background-tertiary whitespace-nowrap rounded-md px-1 py-[1px] text-xs">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};